import { render, staticRenderFns } from "./MenuSettingItems.vue?vue&type=template&id=6c4ad60a&scoped=true&"
import script from "./MenuSettingItems.vue?vue&type=script&lang=js&"
export * from "./MenuSettingItems.vue?vue&type=script&lang=js&"
import style0 from "./MenuSettingItems.vue?vue&type=style&index=0&id=6c4ad60a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4ad60a",
  null
  
)

export default component.exports